import styled from '@emotion/styled';
import { Empty, Spin } from 'antd';
import App from 'antd/lib/app';
import { FC, useEffect, useState } from 'react';

import { API } from '../api';
import { PageTitle } from '../components/common/page-title';
import { PlaylistItem } from '../components/uploaded-videos/uploaded-items/playlist-item';
import { TListedPlaylist } from '../types/responses/video';

const Grid = styled('div')`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
  margin-top: 28px;
`;

export const PlayCoursesPage: FC = () => {
  const { message } = App.useApp();
  const [playlists, setPlaylists] = useState<TListedPlaylist[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.playlists
      .getAssigned()
      .then((response) =>
        setPlaylists(response.data.filter((playlist) => playlist.isCourse))
      )
      .catch(() => message.error('Unable to load assigned courses'))
      .finally(() => setLoading(false));
  }, [message]);

  return (
    <div>
      <PageTitle>PlayCourse</PageTitle>
      {loading ? (
        <Spin />
      ) : playlists.length ? (
        <Grid>
          {playlists.map((playlist) => (
            <PlaylistItem
              key={playlist.id}
              playListData={playlist}
              openAsCourse
            />
          ))}
        </Grid>
      ) : (
        <Empty description="No courses have been assigned yet" />
      )}
    </div>
  );
};
